export default "__VITE_ASSET__B9Gv5HlX__"